import Vue from 'vue'
import gqlQuery from './gql'
import config from '@/config'

Vue.use(gqlQuery, config)

export default new gqlQuery()





// WEBPACK FOOTER //
// ./src/plugins/gql/index.js